import gql from 'graphql-tag';

export default gql`
  query getDownloadableLink($input: DownloadableLinkInput!) {
    getDownloadableLink(input: $input) {
      url
    }
  }
`;
